/**
 * Scroll utility functions for smooth navigation
 */

/**
 * Get the current scroll position from the top of the page
 */
export const getScrollPosition = (): number => {
  if (typeof window === 'undefined') return 0;
  return window.pageYOffset || document.documentElement.scrollTop;
};

/**
 * Check if the current scroll position is near the top of the page
 * @param threshold - Distance in pixels from the top to consider "near top"
 * @returns true if scroll position is within threshold of the top
 */
export const isNearTop = (threshold: number = 200): boolean => {
  return getScrollPosition() <= threshold;
};

/**
 * Smooth scroll to an element by ID
 * @param elementId - The ID of the element to scroll to
 * @param offset - Optional offset in pixels from the top of the element
 */
export const scrollToElement = (elementId: string, offset: number = 0): void => {
  if (typeof window === 'undefined') return;

  const element = document.getElementById(elementId);

  const elementPosition = (element?.getBoundingClientRect().top || 100) + window.pageYOffset;
  const offsetPosition = elementPosition - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};

/**
 * Smooth scroll to the top of the page
 * @param offset - Optional offset in pixels from the top
 */
export const scrollToTop = (offset: number = 0): void => {
  if (typeof window === 'undefined') return;

  window.scrollTo({
    top: offset,
    behavior: 'smooth',
  });
};
